import { createContext, useContext } from 'react';

const CreditsAndPlansContext = createContext();

export function useCreditsAndPlans() {
  return useContext(CreditsAndPlansContext);
}

export default CreditsAndPlansContext;
